import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";

const mutations = {
  [types.GET_HOT_FLOOR_DATA_BEGIN](state) {
    state.hotFloorDataGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_HOT_FLOOR_DATA_SUCCESS](state, hotFloorData) {
    state.hotFloorData = hotFloorData
    state.hotFloorDataGetError = null;
    state.hotFloorDataGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_HOT_FLOOR_DATA_ERROR](state, err) {
    state.hotFloorDataGetState = API_STATES.REQUEST_ERROR;
    state.hotFloorDataGetError = err;
  }
}

export default mutations;
